import { Actions, Atom, Namespace } from "@cirrus/fe-lib"
import { keys, mergeRight, pick } from "ramda"

import { CurrentUser } from "../_params.js"
import { CirrusApi } from "../../../shared/index.js"

import { types as GeneralSettingsTypes } from "@cirrus/legacy/features/author/admin/globalSettings/general/services/actions.es6"

import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

export const domain = Namespace.domain(CurrentUser, "settings")

const initialState = {
  features: {
    "U-enableReadSpeaker": false,
    c_enableReadSpeaker: false,
    candidateFeedbackDefaults: {
      email: null,
      enableCandidateFeedbackOption: false,
    },
    enableCustomItemIntroductionText: false,
    enableKeyApproving: false,
    enableNda: false,
    enableProctorio: false,
    enableVpl: false,
    externalApi: false,
    sowiso: false,
    wiris: false,
  },

  isAdminLoggedIn: false,

  regs: {
    formats: "en-GB",
    lang: "en-US",
    ltformat: "HH:mm:ss",
    offset: 120,
    reg: "Europe",
    stformat: "h:mm A",
    zone: "Europe/Amsterdam",
  },

  settings: {
    arePagesAfterShown: false,
    arePagesBeforeShown: false,
    areQuestionsShown: false,
    availabilityImgUrl: "",
    baseImgixUrl: "",
    baseS3Url: "",
    currentUserId: "",
    customerId: 1,
    firstName: "",
    itemsPerPage: 0,
    mainMenuCollapsed: false,
    navbarCollapsed: false,
    picture: "",
    secondName: "",
    username: "",
  },
}

export const actions = Actions.of(domain, [
  "settingsRequested",
  "settingsFetched",
  "settingsFetchFailed",
  "settingsFetchCancelled",
])

export const atom = Atom.behavior((on) => {
  on(actions.settingsFetched, (state, payload) =>
    mergeRight(state, pick(keys(initialState), payload)),
  )
}, initialState)

export const effects = [
  takeLatest([actions.settingsRequested], function* () {
    if (sessionStorage.getItem("Cirrus_Delivery_Mode") === "Anonymous") {
      yield put(actions.settingsFetchCancelled())
    } else {
      try {
        const { data } = yield call(CirrusApi.user.settingsGet)

        yield put(actions.settingsFetched(data))
      } catch (error) {
        yield put(actions.settingsFetchFailed(error))
      }
    }
  }),

  takeEvery(actions.settingsFetchFailed, function* ({ error }) {
    console.error(error)
  }),
]
